import {Injectable} from '@angular/core';
import {PostLoginLoanApplicationFlowStep} from './post-login-loan-application-flow.step';
import {LoanApplicationInteractor} from '../../interactors/loan-application.interactor';
import {UserInteractor} from '../../interactors/user.interactor';
import {BorrowedInfoInteractor} from '../../interactors/borrowed-info.interactor';

@Injectable()
export class BorrowedInfoStep extends PostLoginLoanApplicationFlowStep {
    constructor(userInteractor: UserInteractor,
                private borrowedInfoInteractor: BorrowedInfoInteractor,
                private loanApplicationInteractor: LoanApplicationInteractor) {
        super(userInteractor);
    }

    description(): string {
        return 'So we can help you plan your loan and EMIs';
    }

    displayName(): string {
        return 'Have you borrowed before?';
    }

    async isStepComplete(): Promise<boolean> {
        const loanApplication = (await this.loanApplicationInteractor.get());
        return loanApplication ? !!await this.borrowedInfoInteractor.getByLoanApplicationId(loanApplication.id) : false;
    }

    url(): string {
        return this.createBorrowerFlowUrl('borrowed-info');
    }
}
